export default {
    START_ALL: 'start all',
    START_ONE: 'start one',
    FINISH_ALL: 'finish all',
    FINISH_ONE: 'finish one',
    PUBLISH_INTERACTIONS: 'publish interactions',
};
